module.exports = __webpack_public_path__ + "img/veliu_namai_interview.a11cffce.jpg";